import CheckboxMui, { CheckboxProps } from "@mui/material/Checkbox";
import theme from "assets/styles/themes";

import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";

const Checkbox = ({ sx, ...otherProps }: CheckboxProps) => (
    <CheckboxMui
        sx={{
            color: theme.palette.neutrals.main,
            "&.Mui-checked": {
                color: `linear-gradient(94.61deg, ${theme.palette.button.active.from} 0%, ${theme.palette.button.active.to} 100%)`,
            },
            "& > .MuiSvgIcon-root": {
                background: theme.palette.common.white,
                fontSize: 13,
            },
            ...sx,
        }}
        icon={<CustomIcon icon={icons.checkbox} />}
        checkedIcon={<CustomIcon icon={icons.checkboxChecked} />}
        indeterminateIcon={<CustomIcon icon={icons.checkboxIndeterminate} />}
        {...otherProps}
    />
);

export default Checkbox;
